import React, { useEffect } from 'react'
import { graphql } from "gatsby"
import "./_style.scss"

import Layout from "§/src/components/layout"
import BreadcrumbCustomLevels from "§/src/components/atoms/breadcrumb/breadcrumb-customlevels"
import SchemaBreadcrumb from "§/src/components/schema/s-breadcrumb"

import Error from "§/src/components/error"
import SEO from "§/src/components/seo"
import LoadingFrame from "§/src/components/atoms/loading-frame"

import { isEmpty } from "lodash"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

import { getFormattedDate, sanitize } from "§/src/utils/functions"

import Layouter from "§/src/components/sections/layouter"
import TextModule from "§/src/components/atoms/content/text-module"
const RelatedTiles = React.lazy(() => import("§/src/components/sections/related-tiles"))
const RelatedLastPost = React.lazy(() => import("§/src/components/sections/related-last-posts"))

const CardsModalByYear = React.lazy(() => import("§/src/components/sections/cards-modal-by-year"))

// Order Related by category color
const sortRelated = (related) => {
const colorOrder = ["#a21942", "#3f7e45", "#fd6825", "#bf8b2e"];
return related.sort((a, b) => {
    return colorOrder.indexOf(a.acfRelatedDatas.color) - colorOrder.indexOf(b.acfRelatedDatas.color);
  });
};

// Switch Language
import { useTranslation } from "react-i18next"
import { getFormattedLanguage } from "§/src/utils/functions"

export function Head(props) {
  const seo = props?.pageContext?.seo || {}
  const mainPage = props?.pageContext?.acfPages_sustainability?.mainPage
  const bodyClass = mainPage === true ? 'sust-main' : 'sust-child'

  return (
    <React.Fragment>
      <html lang={getFormattedLanguage(process.env.GATSBY_SITE_LANG)}></html>
      <body className={'temp-sustainability ' + bodyClass}></body>
      <SEO seo={seo} translations={props?.data?.lang?.translations} />
      <SchemaBreadcrumb breadcrumbs={seo?.breadcrumbs} />
    </React.Fragment>
  )
}

const TemplateSustainability = props => {
  const { t } = useTranslation()
  const data = props?.pageContext?.acfPages_sustainability
  const compLayouter = data?.layouter ? translateToNewFormat(data?.layouter) : false
  const compLayouterBottom = data?.layouterBottom?.layouter ? translateToNewFormat(data?.layouterBottom?.layouter) : false
  const mainText = data?.mainText
  const sdgsLogos = mainText.sdgsLogos
  const related = props?.data?.sustRelated?.nodes
  const sortedRelated = sortRelated(related);
  const mainPage = data?.mainPage
  const relatedTilesTitle = mainPage ? t('I nostri pilastri della sostenibilità') : t('Leggi gli altri pilastri')
  const relatedPostsData = props?.data?.relatedNews
  const relatedPostsTitle = t('Scopri cosa facciamo')
  const pageCategory = props?.pageContext?.acfRelatedDatas?.color


  // FROM DOCUMENTAL BACKEND - Sustainability docs -> reports
  const docsReports = props.pageContext.docsReports || []

  // FROM DOCUMENTAL BACKEND - Sustainability docs ->
  const docsGefranPolicy = props.pageContext.docsGefranPolicy || []
  // display raw documents in page
  const docsGefranPolicyRaw = docsGefranPolicy.map((doc, index) => {
    const documents = doc.media.documents || []
    return {
      title: doc.media.post_title,
      bundle: doc.media.bundletitle,
      files: [...documents],
      date: getFormattedDate(doc.media.date, "D MMMM Y"),
      hour: doc.media.hour,
      dateRaw: doc.media.date,
      year: doc.media.year,
    }
  })
  docsGefranPolicyRaw.sort((a, b) => {
    const x = getFormattedDate(a.dateRaw, "YYYYMMDD")
    const y = getFormattedDate(b.dateRaw, "YYYYMMDD")
    return y.localeCompare(x)
  })

  // console.log('sust V2 props docsReportsRaw', docsReportsRaw)
  // console.log('sust V2 props docsGefranPolicyRaw', docsGefranPolicyRaw)

  useEffect(() => {
    const handleClick = (event) => {
      event.preventDefault();
      const apriCassettoButton = document.querySelector('#apricassetto div[data-bs-toggle="modal"]');
      if (apriCassettoButton) {
        apriCassettoButton.click();
      }
    };

    const addClickListener = () => {
      const sustainabilityDocsLink = document.querySelector('a[href="#sustainability-docs"]');
      if (sustainabilityDocsLink) {
        sustainabilityDocsLink.addEventListener('click', handleClick);
      }
    };

    // Use a timeout to ensure the DOM is fully loaded
    const timeoutId = setTimeout(addClickListener, 1000);

    return () => {
      clearTimeout(timeoutId);
      const sustainabilityDocsLink = document.querySelector('a[href="#sustainability-docs"]');
      if (sustainabilityDocsLink) {
        sustainabilityDocsLink.removeEventListener('click', handleClick);
      }
    };
  }, []);

  return (
    <Layout lang={props?.data?.lang?.translations}>
      <BreadcrumbCustomLevels
        levels="1"
        wpseo={props?.pageContext?.seo?.breadcrumbs}
        className=""
      />

      {!isEmpty(props?.pageContext) ? (
        <React.Suspense fallback={<LoadingFrame />}>

          {compLayouter && <Layouter data={compLayouter} className="layouter-top"/>}

          { mainText.title &&
            <TextModule
              pretitle={mainText?.preTitle}
              title={mainText?.title}
              titleImage={mainText?.titleImage}
              titleMultiImage ={mainText?.sdgsLogos}
              content={mainText?.content}
              cta={mainText?.cta}
              orientation={mainText?.textModuleOrientation}
              template={mainText?.template}
              positionInBundle={mainText?.positionInBundle}
              downloadstitle={mainText?.downloads?.title}
              downloadsfiles={mainText?.downloads?.downloadFiles}
              twotilesandimage={mainText?.twoTilesAndImage}
              reports={mainText?.reports}
              className={"sust-child-text-image pb-7 mb-0"}
            />
          }

          {compLayouterBottom && !mainPage && <Layouter data={compLayouterBottom} className="layouter-bottom"/>}

          {!mainPage &&
            <RelatedLastPost data={relatedPostsData} title={relatedPostsTitle} category={pageCategory}/>
          }

          {related &&
            <RelatedTiles data={sortedRelated} title={relatedTilesTitle}/>
          }

          {compLayouterBottom && mainPage && <Layouter data={compLayouterBottom} customData={docsGefranPolicyRaw} className="layouter-bottom"/>}

          <CardsModalByYear
            onlyModal={true}
            documentsList={docsReports}
            className="ghost"
          />

        </React.Suspense>
      ) : (
        <Error message="Something Went Wrong" />
      )}
    </Layout>
  )
}
export default TemplateSustainability

export const pageQuery = graphql`
  query GET_TRANSLATIONS($eq: String!) {
    sustRelated: allWpPage(
      filter: {
        template: {templateName: {eq: "Sustainability"}},
        slug: {nin: [$eq]},
        acfPages_sustainability: {enableV2: {eq: true}, mainPage: {ne: true}}
      }
    ) {
      nodes {
        uri
        title
        acfRelatedDatas {
          color
          pretitle
          title
          content
        }
        featuredImage {
          node {
            altText
            gatsbyImage(aspectRatio: 0.745, width: 350, placeholder: BLURRED, formats: [AUTO, WEBP])
          }
        }
      }
    }
    relatedNews: allWpPost(
      sort: { date: DESC }
      filter: {
        categories: {
          nodes: {
            elemMatch: {
              slug: { eq: "sustainability"
              }
            }
          }
        }
      }
    ) {
      nodes {
        title
        excerpt
        uri
        date
        featuredImage {
          node {
            altText
            gatsbyImage(
              quality: 80
              aspectRatio: 1.6
              placeholder: BLURRED
              layout: CONSTRAINED
              width: 500
              formats: [AUTO, WEBP]
            )
          }
        }
        categories {
          nodes {
            slug
          }
        }
      }
    }
    lang: wpPage(uri: { eq: $eq }) {
      translations {
        postUrl
        siteId
      }
    }
  }
`

const translateToNewFormat = data => {
  data = [...data]
  for (const elem of data) {
    if (elem && elem.downloadFiles) {
      elem.downloadFiles = elem.downloadFiles.map(x => ({
        title: x.title,
        fieldGroupName: x.fieldGroupName,
        files: [{ ...x.file, title: x.title }],
        file: { ...x.file, title: x.title },
      }))
    }
    if (elem && elem.downloads && elem.downloads.downloadFiles) {
      elem.downloads.downloadFiles = elem.downloads.downloadFiles.map(x => ({
        title: x.title,
        fieldGroupName: x.fieldGroupName,
        files: [{ ...x.file, title: x.title }],
        file: { ...x.file, title: x.title },
      }))
    }
  }
  return data
}
